import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'

const LICENSE_APPLY_REQUIREMENTS_API_PATH = '/api/v4/license/bit/web/regulator/license/apply/requirements'

export type LicenseApplyRequirementItem = {
  title?: string
  content?: string
}

export type LicenseApplyRequirementsResponse = {
  code?: number
  data?: {
    items?: LicenseApplyRequirementItem[]
  }
  items?: LicenseApplyRequirementItem[]
  message?: string
  succeed?: boolean
}

type LicenseApplyRequirementsParams = {
  urlSlug?: string
  regulatorCode?: string
}

/** 获取监管机构牌照申请要求。 */
export const getRegulatorLicenseApplyRequirements = (
  params: LicenseApplyRequirementsParams,
): Promise<LicenseApplyRequirementsResponse | null> => {
  const { urlSlug, regulatorCode } = params
  const requestParams = urlSlug ? { urlSlug } : { regulatorCode }

  if (!urlSlug && !regulatorCode) {
    return Promise.resolve(null)
  }

  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikilicenseGo : api.v4,
    url: LICENSE_APPLY_REQUIREMENTS_API_PATH,
    method: 'GET' as const,
    params: requestParams,
  }

  return import.meta.server
    ? useServerFetch<LicenseApplyRequirementsResponse>(requestConfig)
    : request<unknown, LicenseApplyRequirementsResponse>(requestConfig)
}
